(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219],{

/***/ 9104:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(35911);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Atoms_Card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12744);
/* harmony import */ var _custom_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21191);
/* harmony import */ var _custom_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_custom_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function CustomPage(param) {
    let { page  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_custom_module_scss__WEBPACK_IMPORTED_MODULE_2___default().custom),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Atoms_Card__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: page === null || page === void 0 ? void 0 : page.content
                }
            })
        })
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CustomPage);


/***/ }),

/***/ 21191:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom":"custom_custom__P0_IU"};

/***/ }),

/***/ 12744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);



function Card(_a) {
    var children = _a.children, classes = _a.classes;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('card', classes) }, children);
}


//# sourceMappingURL=Card.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(9104); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);